import React from 'react';
import { SearchOff } from '@mui/icons-material';
import { CircularProgress, Stack, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { MUIBaseEntity, MUITableBodyProps } from './types';
import { RenderWithFallback } from '../Conditional/RenderWithFallback';
import { RenderWithCondition } from '../Conditional/RenderWithCondition';

export const MuiTableBody = <TableEntity extends MUIBaseEntity>({
  hover,
  columns,
  tableData,
  isLoading,
  onRowClick,
}: MUITableBodyProps<TableEntity>) => {
  return (
    <TableBody>
      <RenderWithFallback
        isLoading={!tableData.length && isLoading}
        fallBack={
          <TableRow>
            <TableCell colSpan={columns.length} align="center">
              <Stack direction="row" alignItems="center" justifyContent="center" gap="1rem">
                <CircularProgress size={20} /> <Typography>Loading...</Typography>
              </Stack>
            </TableCell>
          </TableRow>
        }
      >
        <RenderWithCondition
          condition={!!tableData.length}
          fallBack={
            <TableRow>
              <TableCell colSpan={columns.length} align="center">
                <Stack direction="row" alignItems="center" justifyContent="center" gap="1rem">
                  <SearchOff />
                  <Typography>No data</Typography>
                </Stack>
              </TableCell>
            </TableRow>
          }
        >
          {tableData.map(entity => (
            <TableRow
              key={entity.id}
              hover={hover}
              className="tableRow"
              onClick={e => onRowClick && onRowClick(e, entity)}
            >
              {columns.map(({ header, renderKey, renderCell, formatter }) => (
                <TableCell key={`${header}_${renderKey}`} align="center">
                  {typeof renderCell === 'function'
                    ? renderCell(entity, entity[renderKey])
                    : formatter
                      ? formatter(entity)
                      : (entity[renderKey] ?? '-')}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </RenderWithCondition>
      </RenderWithFallback>
    </TableBody>
  );
};
